import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PosIntegrationService } from '../../../../../../services/pos-integration.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-retailexpress-defaults',
  templateUrl: './retailexpress-defaults.component.html',
  styleUrls: ['./retailexpress-defaults.component.scss'],
  providers: [MessageService],
})
export class RetailexpressDefaultsComponent implements OnInit {
  @Input() partner;
  @Output() status = new EventEmitter();
  public partnerID;
  public busy = true;
  public config: any = {};
  public registers: any = [];
  public taxes: any = [];
  public users: any = [];
  public locations: any = [];
  public paymentTypes: any = [];
  public isWizard: boolean = false;

  constructor(
    private posIntegrationService: PosIntegrationService,
    private messageService: MessageService,
    private translate: TranslateService,
    private router: Router,
  ) {
    if (this.router.url.indexOf('bikeshop-wizard') > -1) {
      this.isWizard = true;
    }
  }

  ngOnInit() {
    this.partnerID = this.partner.ID || this.partner.PartnerID;
    this.getLocations();
    this.getPaymentTypes();
    this.getConfig();
  }

  getConfig() {
    this.posIntegrationService.getConfig(this.partnerID).subscribe(res => {
      this.config = res;
      console.log(this.config);
      this.busy = false;
     }, err => {
      this.busy = false;
     });
     this.busy = false;
  }

  getLocations() {
    this.posIntegrationService
      .getRetailExpressLocations(this.partnerID)
      .subscribe((res) => {
        this.locations = res.map((x) => {
          return { label: x.Name, value: x.ID.toString() };
        });
      });
  }

  getPaymentTypes() {
    this.posIntegrationService.getRetailExpressPaymentTypes(this.partnerID).subscribe(res => {
      this.paymentTypes = res.map(x => { return { label: x.label, value: parseInt(x.value) } });
    });
  }

  updateConfig() {
    this.busy = true;
    this.config.ID = this.partnerID;

    console.log(this.config);

    this.posIntegrationService
      .updateRetailExpressConfig(this.partnerID, this.config)
      .subscribe(
        (result) => {
          this.busy = false;
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant('onboarding.pos_settings_updated'),
          });
          this.status.emit({ configurationSaved: true });
        },
        (err) => {
          this.busy = false;
        },
      );
  }
}
